import classnames from "classnames";
import React from "react";
import Icon from "../../../components/icon/icon";
import LoadingSpinner from "../../../components/loading-spinner/loading-spinner";
import Percent from "../../../components/numbers/percent";
import { sortedSelectedInvestmentsSelector } from "../../../selectors/investments";
import {
  accountsStatusSelector,
  datesStatusSelector,
  investmentsStatusSelector,
  useStatuses,
} from "../../../selectors/status";
import { useSelector } from "../../../store/store";
import {
  calculateTotalPRR,
  calculateTotalRateOfReturn,
  calculateTotalEndBalanceV2,
} from "../../../util/investments";
import "./prr-total-display.scss";
import { getDashFormattedDateStringFromISOString } from "../../../util/date-util";
import { useDates } from "../../../selectors/dates";
import { useLiabilitiesRestApi } from "../../../selectors/feature-flags";

export default function PrrTotalDisplay() {
  const sortedInvestments = useSelector(sortedSelectedInvestmentsSelector);
  const { isLoadingStatus } = useStatuses([
    accountsStatusSelector,
    datesStatusSelector,
    investmentsStatusSelector,
  ]);
  const {
    startDate,
    endDate,
    investmentSummaryStartDate,
    investmentSummaryEndDate,
  } = useDates();
  const useLiabilitiesApi = useSelector(useLiabilitiesRestApi);
  const hasBalance = calculateTotalEndBalanceV2(sortedInvestments) > 0;
  const total = useLiabilitiesApi
    ? calculateTotalPRR(sortedInvestments)
    : calculateTotalRateOfReturn(sortedInvestments);
  const arrowClasses = classnames([
    total >= 0 ? "arrow-up green" : "arrow-down red",
  ]);

  if (isLoadingStatus) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <div className="prr-total-display" data-testid="prr-display">
        <div className="prr-value">
          {hasBalance ? (
            <>
              <Icon name={arrowClasses} />
              &nbsp;
              <Percent value={total} />
            </>
          ) : (
            <span>N/A</span>
          )}
        </div>
        <p>
          <strong className="show">From dates</strong>
          <>
            {getDashFormattedDateStringFromISOString(
              investmentSummaryStartDate!
            )}{" "}
            through{" "}
            {getDashFormattedDateStringFromISOString(investmentSummaryEndDate!)}
          </>
        </p>
      </div>
    </>
  );
}
